import { render, staticRenderFns } from "./BookingsCalendar.vue?vue&type=template&id=67512e8c"
import script from "./BookingsCalendar.vue?vue&type=script&lang=js"
export * from "./BookingsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports